import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, Image, Link, Text, Heading } from "@chakra-ui/react";
import React from "react";
import { SiGithub } from "react-icons/si";
import img1 from "./images/dermstore.png";
import img2 from "./images/myglam.png";
import img3 from "./images/airtable.png";
import img4 from "./images/caratelane.png";
import img5 from "./images/Lime.png";
import img6 from "./images/course.png";


const Project = () => {
  return (
    <Box id="Project">
      <Box w="80%" m="auto" p="98px 0px 60px 0px">
        <Box>
          <Heading
            fontSize={["35px", "35px", "55px"]}
            p="30px"
            display="flex"
            justifyContent="center"
            fontFamily="Serif"
            data-aos="fade-down"
          >
            Projects
          </Heading>
          <Box
            display="grid"
            m="auto"
            mt="10"
            gridTemplateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
            ]}
            gap="80px"
          >
             <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
             
            >
              <Box>
                <Image
                  m="auto"
                  p={["0px 20px", "", ""]}
                  src={img6}
                  borderRadius="5%"
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    Course App
                  </Text>
                  <Text
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    fontFamily="Serif"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
                   This is a fullstack project which is similar as Udemy 
                   where user can access and uplaod the courses with Admin controls and traking dashboard,with Dark and light theme 
                  </Text>
                  <Text
                    fontFamily="Serif"
                    fontSize={["xl", "2xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                  >
                    TechStack : HTML , CSS , JavaScript, React.Js ,Redux,MongoDb , Node.Js,Express.Js, Chart.Js , Rest Api
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      fontFamily="Serif"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://coursestartup.vercel.app"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      fontFamily="Serif"
                      href="https://github.com/mrprincesingh/courseappfrontend"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
             
            >
              <Box>
                <Image
                  m="auto"
                  p={["0px 20px", "", ""]}
                  src={img2}
                  borderRadius="5%"
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    MyGlam.com
                  </Text>
                  <Text
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    fontFamily="Serif"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
                    it was a group project of 5 members which was completed with
                    in 5days , MyGlam is a ecommerce website which is
                    specialized in Beauty product
                  </Text>
                  <Text
                    fontFamily="Serif"
                    fontSize={["xl", "2xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                  >
                    TechStack : HTML , CSS , JavaScript
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      fontFamily="Serif"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://delicate-alfajores-3592c1.netlify.app/"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      fontFamily="Serif"
                      href="https://github.com/mrprincesingh/MyGlamm"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
             
            >
              <Box>
                <Image
                  m="auto"
                  p={["0px 20px", "", ""]}
                  borderRadius="5%"
                  src={img1}
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    Dermstore.com
                  </Text>
                  <Text
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    fontFamily="Serif"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
                    it was a group project of 5 members which was completed with
                    in 5days Dermstore is US web store which sells cosmetics and
                    skin care products.
                  </Text>
                  <Text
                    fontSize={["xl", "2xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                    fontFamily="Serif"
                  >
                    TechStack : HTML , CSS , JavaScript
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      fontFamily="Serif"
                      href="https://dermstore-clone-chi.vercel.app/"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      fontFamily="Serif"
                      href="https://github.com/nrishav007/Dermstore_Clone"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
              
            >
              <Box>
                <Image
                  m="auto"
                  borderRadius="5%"
                  p={["0px 20px", "", ""]}
                  src={img3}
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    Airtable.com
                  </Text>
                  <Text
                    fontFamily="Serif"
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
                    It was a group project of 5 members which was completed with
                    in 5days ,software creation by enabling anyone to build the
                    tools that meet their needs.world use Airtable to do
                    everything like cattle tracking.
                  </Text>
                  <Text
                    fontSize={["xl", "xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                    fontFamily="Serif"
                  >
                    TechStack : HTML , CSS , JavaScript,ReactJS, Redux, chakra-ui
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://webtaskit.vercel.app/"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://github.com/SunilHooda/Airtable.com-Clone"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
             
            >
              <Box>
                <Image
                  m="auto"
                  borderRadius="5%"
                  p={["0px 20px", "", ""]}
                  src={img4}
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    Caratlane.com
                  </Text>
                  <Text
                    fontFamily="Serif"
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
                    It was a group project of 4 members which was completed with
                    in 5days ,caratlane is a ecommerce website which is specialized in Jewellery 
                  </Text>
                  <Text
                    fontSize={["xl", "xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                    fontFamily="Serif"
                  >
                    TechStack : HTML5, CSS3, Javascript, ES6, chakra-ui, ReactJS, Redux ,MongoDB Atlas , nodejs , express js.
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://24karat.netlify.app/"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://github.com/mrprincesingh/freezing-value-6715"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              _hover={{
                transform: "scale(1.05)",
                transition: "transform, 0.5s",
              }}
              p="20px 0px"
              border="1px"
              borderRadius="20px"
             
            >
              <Box>
                <Image
                  m="auto"
                  borderRadius="5%"
                  p={["0px 20px", "", ""]}
                  src={img5}
                  alt="img"
                />
              </Box>
              <Box>
                <Box>
                  <Text
                    fontSize={["2xl", "3xl", "4xl"]}
                    fontFamily="Serif"
                    align="center"
                    mt="30px"
                  >
                    LimeRoad.com
                  </Text>
                  <Text
                    fontFamily="Serif"
                    fontSize={["10", "10", "12", "20"]}
                    textAlign="justify"
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                  >
A group project that is made during the time span of 5 days.LimeRoad is a revolutionary Online Shopping Website and Discovery Platform for Fashionable Men and Women ·
                  </Text>
                  <Text
                    fontSize={["xl", "xl", "2xl"]}
                    m={["10px 30px", "10px 40px", "15px 40px"]}
                    align="center"
                    fontFamily="Serif"
                  >
                    TechStack : HTML5, CSS3, Javascript, ReactJS, Redux , chakra-ui
                  </Text>
                </Box>
                <Box
                  m="auto"
                  mt="20px"
                  gap={1}
                  display="flex"
                  w="50%"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["2px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://limeroadclone.vercel.app/"
                    >
                      Live
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Box>
                  <Box>
                    <Link
                      _hover={{ textDecoration: "none", bg: "#141f1f" }}
                      borderRadius="5px"
                      p={["10px 5px", "10px 15px", "10px 15px"]}
                      bg="gray"
                      color="white"
                      display="flex"
                      gap={["4px", "10px", "10px"]}
                      alignItems="center"
                      target="_blank"
                      href="https://github.com/Anurag8305/Co-Commerce"
                    >
                      Github
                      <SiGithub mx="2px" />
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Project;
